import { Controller } from "@hotwired/stimulus";

// Fire a Meta Pixel custom event on click. No-ops in any
// environment where the pixel hasn't loaded (dev / staging
// / blocked by ad-blocker), so the action is always safe to
// wire up.
//
// Usage:
//   <a data-controller="meta-pixel"
//      data-action="click->meta-pixel#track"
//      data-meta-pixel-event-value="Contact">
export default class extends Controller {
  static values = {
    event: String,
  };

  track() {
    if (!this.eventValue) {
      console.warn("meta-pixel: event value not set");
      return;
    }
    if (typeof window.fbq !== "function") {
      // Pixel didn't load (dev/staging gate, or blocked).
      // Silently no-op: server-side CAPI is the fallback.
      return;
    }
    window.fbq("track", this.eventValue);
  }
}
